import { useQuery } from '@tanstack/react-query'
import { searchApiService } from 'api/services'
import { IUseSearch } from 'api/types/search'
import { QUERY_KEY } from 'app/constants'
import { useMemo } from 'react'

type Props = {
  query: string
  enabled: boolean
}

export const useSearch = ({ query, enabled }: Props): IUseSearch => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEY.search, { query }],
    queryFn: () => searchApiService.getSearch(query),
    select: (data) => data.data,
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  })

  return useMemo(() => {
    return {
      data: data ?? [],
      isLoading,
    }
  }, [data, isLoading])
}
